<template>
  <div class="supplier-payment body">
    <el-container>
      <!-- <CustomersAside /> -->
      <el-main>
        <el-row :gutter="10">
          <el-col :xl="9" :lg="9" :md="6" :sm="12">
            <div class="bg-White h">
              <SearchSuppliers
                ref="searchSuppliersComponent"
                :searchOnly="true"
                :supplier="supplier"
                @selectedSupplier="selectedSupplier"
                :productsLength="productsLength"
                :productSearch="false"
                :showLabel="true"
              />
            </div>
          </el-col>
          <el-col :xl="9" :lg="9" :md="10" :sm="12" class="bg-White">
            <div class="block p-sm-3 mt-2">
              <label for="" class="d-block"> اختر مده زمنيه</label>
              <el-date-picker
                style="width: 100%"
                @change="getSupplierReportNew"
                v-model="dateRange"
                type="daterange"
                range-separator="الي"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
                start-placeholder="بداية الفترة"
                end-placeholder="نهاية الفترة"
                class="display-mobile-none"
              >
              </el-date-picker>
              <el-date-picker
                type="date"
                class="filter-mobile"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
                @change="getSupplierReportNew"
                v-model="startDate"
                placeholder="بداية الفترة"
              />
              <el-date-picker
                type="date"
                class="filter-mobile"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
                @change="getSupplierReportNew"
                v-model="endDate"
                placeholder="نهاية الفترة"
              />
            </div>
          </el-col>
          <el-col :xl="4" :lg="4" :md="4" :sm="12" v-if="supplier">
            <div class="bg-White result">
              <p class="p-sm-3 mt-2">
                <span
                  class="num"
                  v-if="+supplier.balance + +supplier.account >= 0"
                >
                  {{ numberToFixed(+supplier.balance + +supplier.account) }}
                </span>
                <span class="num" v-else>
                  {{
                    numberToFixed(+supplier.balance + +supplier.account * -1)
                  }}
                </span>
                <br class="display-mobile-none" />
                <span v-if="+supplier.balance + +supplier.account >= 0"
                  >دائن</span
                >
                <span v-else>مدين</span>
              </p>
            </div>
          </el-col>
          <el-col :lg="2" :md="4" :sm="12">
            <div class="bg-White result" style="height: 100%" v-if="supplier">
              <el-button
                type="success"
                @click="printAllProducts"
                icon="el-icon-printer"
              ></el-button>
            </div>
          </el-col>
        </el-row>
        <el-row
          class="bg-White mt-2 p-3"
          v-if="supplier"
          justify="space-between"
        >
          <el-col :xl="18" :lg="18" :md="18" :sm="24">
            كشف حساب الموردين
          </el-col>
          <el-col :xl="6" :lg="6" :md="6" :sm="24">
            <label for="code"></label>
            <el-input
              placeholder="بحث بالبيان "
              autofocus
              type="text"
              @focus="$event.target.select()"
              v-model="description"
            ></el-input>
          </el-col>
        </el-row>
        <el-table
          class="mt-2 table-mobile"
          align="right"
          v-if="tableData.length > 0"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            label="#"
            type="index"
            width="50"
            class-name="display-mobile-none"
          />
          <el-table-column width="90" label="السند" prop="operation_id">
            <template slot-scope="scope">
              <span class="label"> {{ scope.$index + 1 }} # السند </span>
              <div>{{ scope.row.operation_id }}</div>
            </template>
          </el-table-column>
          <el-table-column width="155" label="التوقيت" prop="created_at">
            <template slot-scope="scope">
              <span class="label">التوقيت</span>
              <div>
                {{ scope.row.created_at | moment(" Do / MM / YYYY | h:mm A") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="350" label="بيان" prop="description">
            <template slot-scope="scope">
              <span class="label">بيان</span>
              <div>{{ scope.row.description }}</div>
            </template>
          </el-table-column>
          <el-table-column label="دائن">
            <template slot-scope="scope">
              <span class="label">دائن</span>
              <div>
                <span v-if="scope.row.type == 1">{{ scope.row.amount }}</span>
                <span v-else></span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label=" مدين">
            <template slot-scope="scope">
              <span class="label">مدين</span>
              <div>
                <span v-if="scope.row.type == 0">{{ scope.row.amount }}</span>
                <span v-else></span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="الرصيد" prop="account">
            <template slot-scope="scope">
              <span class="label">الرصيد</span>
              <div>{{ scope.row.account }}</div>
            </template>
          </el-table-column>
          <el-table-column label="بواسطة" prop="user.name">
            <template slot-scope="scope">
              <span class="label">بواسطة</span>
              <div>{{ scope.row.user.name }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="اجراء"
            v-if="accessLinks('edit_supplier_payment_movement')"
          >
            <template slot-scope="scope">
              <el-button
                v-if="
                  scope.row.operation_type == 1 || scope.row.operation_type == 4
                "
                size="mini"
                type="warning"
                title="تعديل"
                icon="el-icon-edit"
                @click="edit(scope.row)"
              >
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
    <el-dialog
      :fullscreen="false"
      title="تعديل قيمة بيان"
      :visible.sync="editMode"
    >
      <el-form v-model="form">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="المبلغ">
              <el-input v-model="form.amount" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="المبلغ الجديد">
              <el-input v-model="form.cost"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="update">حفظ التعديلات</el-button>
        <el-button class="mr-3" @click="editMode = false">إلغاء</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import SearchSuppliers from "@/components/Suppliers/SearchWithoutAdd.vue";
// import { ipcRenderer } from "electron";
// import CustomersAside from "@/components/CustomersAside.vue";
import axiosApi from "@/plugins/axios.js";

export default {
  name: "supplierReport",
  components: { SearchSuppliers },
  data() {
    return {
      false: false,
      true: true,
      dateRange: null,
      tableData: [],
      allData: [],
      type: null,
      productsLength: 0,
      supplier: null,
      payments: 0,
      sales: 0,
      account: 0,
      description: "",
      editMode: false,
      form: {
        account: 0,
        amount: "",
        cost: 0,
        created_at: "",
        customer_id: 0,
        description: "",
        id: 0,
        operation_id: 0,
        operation_type: 0,
        role_name: "",
        type: 0,
        updated_at: "",
        user: null,
        user_id: 0,
      },
      startDate: "",
      endDate: "",
    };
  },
  created() {
    //  console.log("this.$route.params",this.$route.query);
    if (this.$route.query.supplier_id > 0) {
      this.getSupplier();
    }
    axiosApi.get("logs/suppliers/104").then((res) => {
      console.log(res);
    });
  },
  watch: {
    description: function (newValue) {
      this.tableData = this.allData;
      let query = newValue.trim();
      if (query != "") {
        this.tableData = this.tableData.filter((value) => {
          return value.description.includes(query);
        });
      } else {
        this.tableData = this.allData;
      }
    },
  },
  methods: {
    getSupplier() {
      axiosApi
        .get(`suppliers/${this.$route.query.supplier_id}`)
        .then((res) => {
          this.supplier = res.data;
          this.$refs.searchSuppliersComponent.setValue(this.supplier);
          this.getSupplierReportNew();
        })
        .catch((error) => console.log(error))
        .finally(() => {});
    },
    selectedSupplier(e) {
      this.supplier = e.supplier;
      this.getSupplierReportNew();
      setTimeout(() => {
        // document.getElementById("paied").focus();
      }, 100);
    },
    filterByType() {
      if (this.type && this.type != "") {
        const vm = this;
        this.tableData = this.tableData.filter((item) => {
          if (item.comment) {
            if (item.comment.includes(vm.type)) {
              return item;
            }
          }
        });
      } else {
        this.tableData = this.allData;
      }
    },

    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    getSupplierReport() {
      if (this.supplier) {
        const loading = this.$loading({
          lock: true,
          text: "جاري تحميل البيانات",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        let url = `suppliers/interval-report/${this.supplier.id}`;
        if (this.dateRange != null) {
          url += `?start_date=${this.dateRange[0]}`;
          url += `&end_date=${this.dateRange[1]}`;
        }

        axiosApi
          .get(url)
          .then((response) => {
            this.supplier_old_account = response.data.old;

            this.tableData = response.data.supplier_report;
            const vm = this;

            this.tableData.unshift({
              comment: "رصيد سابق",
              cost: vm.numberToFixed(response.data.old),
              created_at: "",
              donne_at: "",
              id: "",
              type: 1,
            });
            let sum = 0;
            let sales = 0;
            let payment = 0;
            this.tableData.map(function (value) {
              if (value["type"] == 1) {
                sum += value["cost"];
                sales += value["cost"];
              } else {
                sum -= value["cost"];
                payment += value["cost"];
              }

              value["account"] = vm.numberToFixed(sum);
            });

            if (this.supplier_old_account > 0) {
              sales += this.supplier_old_account;
            } else {
              payment += this.supplier_old_account * -1;
            }
            this.account = sales - payment;

            this.payments = payment;
            this.sales = sales;

            this.allData = this.tableData;
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            loading.close();
          });
      } else {
        this.allData = [];
        this.tableData = [];
      }
    },
    getSupplierReportNew() {
      if (this.supplier) {
        const loading = this.$loading({
          lock: true,
          text: "جاري تحميل البيانات",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let url = `logs/suppliers/${this.supplier.id}`;
        if (this.dateRange != null) {
          url += `?start=${this.dateRange[0]}`;
          url += `&end=${this.dateRange[1]}`;
        }
        if (this.startDate) {
          url += `?start=${this.startDate}`;
        }
        if (this.endDate) {
          url += `&end=${this.endDate}`;
        }
        axiosApi
          .get(url)
          .then((response) => {
            this.tableData = response.data.supplier_report;
            this.supplier = response.data.supplier;
            const vm = this;
            if (this.dateRange != null) {
              this.tableData.unshift({
                operation_id: "",
                description: "رصيد سابق",
                account: vm.numberToFixed(response.data.old),
                created_at: this.dateRange[0],
                amount: vm.numberToFixed(response.data.old),
                type: 1,
                user: { name: "" },
              });
            }
            let sum = 0,
              sales = 0,
              payment = 0;
            this.tableData.map(function (value) {
              if (value["type"] == 1) {
                sum += Number(value["amount"]);
                sales += Number(value["amount"]);
              } else {
                sum -= Number(value["amount"]);
                payment += Number(value["amount"]);
              }
              value["account"] = vm.numberToFixed(sum);
            });
            this.account = sales - payment;
            this.payments = payment;
            this.sales = sales;
            this.allData = this.tableData;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            loading.close();
          });
      } else {
        this.allData = [];
        this.tableData = [];
      }
    },
    // printAllProducts() {
    //   window.ipcRenderer = ipcRenderer;
    //   let data = {
    //     data: this.allData,
    //     type: "CustomersReport",
    //     customer: { ...this.supplier, isCustomer: false },
    //     dateRange: this.dateRange,
    //     img:
    //       "https://pos.staging.fatura-app.com" +
    //       JSON.parse(localStorage.getItem("branch")).logo,
    //   };

    //   ipcRenderer.send("printing", data);
    // },
    edit(repot) {
      this.editMode = true;
      this.form = { ...repot, cost: 0 };
    },
    update() {
      console.log(this.form);
      axiosApi
        .put(`supplier-payments/${this.form.operation_id}`, this.form)
        .then(() => {
          this.editMode = false;
          this.getSupplierReportNew();
        });
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  max-height: 70%;
  overflow-y: scroll;
}
</style>
